module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.23fa8d02.png";